<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M2.9165 5.83333C2.9165 3.99238 4.40889 2.5 6.24984 2.5C8.09079 2.5 9.58317 3.99238 9.58317 5.83333C9.58317 7.67428 8.09079 9.16667 6.24984 9.16667C4.40889 9.16667 2.9165 7.67428 2.9165 5.83333Z"
    fill="currentColor"
  />
  <path
    d="M10.4165 5.83333C10.4165 3.99238 11.9089 2.5 13.7498 2.5C15.5908 2.5 17.0832 3.99238 17.0832 5.83333C17.0832 7.67428 15.5908 9.16667 13.7498 9.16667C11.9089 9.16667 10.4165 7.67428 10.4165 5.83333Z"
    fill="currentColor"
  />
  <path
    d="M6.24961 10C9.14184 10 11.7829 12.3807 12.0809 16.6081L12.1438 17.5H0.355469L0.418342 16.6081C0.716335 12.3807 3.35738 10 6.24961 10Z"
    fill="currentColor"
  />
  <path
    d="M19.6436 17.5H13.8144L13.7432 16.4909C13.5708 14.0442 12.6886 12.0085 11.3573 10.5826C12.1001 10.1985 12.9143 10 13.7494 10C16.6417 10 19.2827 12.3807 19.5807 16.6081L19.6436 17.5Z"
    fill="currentColor"
  />
</svg>
